import React from "react";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { useForm } from "react-hook-form";
import InputField from "../../../common/components/FormFields/InputField";
import { Box, Modal } from "@mui/material";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";

const GetIndentModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  height: "20%",
  overflowY: "scroll",
  bgcolor: "background.paper",
  boxShadow: 20,
  p: 4,
};

export default function UsgDateModal(props) {
  const defaultValues = {
    usgDate: new Date(),
    weeks: 0,
    days: 0,
  };

  const { watch, setValue, control } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  const [usgDate, weeks, days] = watch(["usgDate", "weeks", "days"]);

  const handleAddUsgDetails = () => {
    let gaObject = {
      weeks: weeks,
      days: days,
    };

    props?.fnCalculateEdd(usgDate, gaObject);
    props?.close();
  };
  return (
    <div className="mt-10">
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={GetIndentModalStyle}
          className="max-h-[88%] xl:max-h-[80%] h-[70%]"
        >
          <div className="grid grid-cols-1 md:grid-cols-1  w-full ">
            <div className="flex justify-between items-center">
              <label className="whitespace-nowrap font-semibold text-lg	">
                Add USG Date
              </label>
              <CancelPresentationIconButton
                onClick={() => {
                  props.close();
                }}
              />
            </div>
            <div className="grid grid-cols-3 gap-2 items-center my-3">
              <div>
                <DatePickerField
                  label={"USG Date"}
                  inputFormat={"dd/MM/yyyy"}
                  control={control}
                  name={"usgDate"}
                />
              </div>
              <div className="flex gap-2 items-center">
                <div className="w-12">
                  <InputField
                    control={control}
                    name={"weeks"}
                    type={"number"}
                  />
                </div>
                <div className="text-lg font-semibold tracking-wide">Weeks</div>
                <div className="w-12">
                  <InputField control={control} name={"days"} type={"number"} />
                </div>
                <div className="text-lg font-semibold tracking-wide">Days</div>
              </div>
              <div>
                <CommonButton
                  label={"Add"}
                  type={"button"}
                  className={
                    "px-3 border border-customBlue text-customBlue rounded"
                  }
                  onClick={handleAddUsgDetails}
                />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

